import { Divider as Mui5Divider } from '@mui/material'
import React from 'react'

import { useTheme } from '@mui/material/styles'

type SectionDividerProps = {
  marginTop?: number
  marginBottom?: number
  className?: string
}

export const SectionDivider: React.FC<SectionDividerProps> = ({ marginTop = 40, marginBottom = 40, className }) => {
  const theme = useTheme()
  return (
    <Mui5Divider
      className={className}
      component="hr"
      style={{
        marginTop,
        marginBottom,
        borderColor: theme.palette.neutralGrey ? theme.palette.neutralGrey[500] : undefined,
      }}
    />
  )
}
